import { styled } from "webapp/styled-components";

export const HorizontalCalendarStyle = styled.div`
    position: relative;

    overflow: hidden;

    .cal {
        display: flex;
        justify-content: space-between;
    }

    .cal-day-picker {
        display: flex;
        flex-direction: column;
        color: ${p => p.theme.fgColorDark};

        .day-label {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            ${p => p.theme.fontStyles.Header6}
        }

        .day-number {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 100px;

            cursor: pointer;

            ${p => p.theme.fontStyles.Body4}
        }
    }

    .cal-day-picker.weekend {
        color: ${p => p.theme.fgColorLight};
    }

    .cal-day-picker.today:not(.selected) {
        .day-number {
            color: ${p => p.theme.fgColorDark};
            background-color: ${p => p.theme.separatorColor};
        }
    }

    .cal.prev {
        position: absolute;
        left: -100%;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .cal.next {
        position: absolute;
        right: -100%;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;
